module.exports = __webpack_public_path__ + "static/journal.d2d60945.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/journal.jpg
// module id = 352
// module chunks = 35783957827783